import { create } from 'zustand';
import type { AuthUser } from '@/lib/api';

type AuthState = {
  user: AuthUser | null;
  accessToken: string | null;
  isHydrating: boolean;

  setSession: (user: AuthUser, accessToken: string) => void;
  clearSession: () => void;
  setHydrating: (v: boolean) => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  isHydrating: true,

  setSession: (user, accessToken) => set({ user, accessToken, isHydrating: false }),
  clearSession: () => set({ user: null, accessToken: null, isHydrating: false }),
  setHydrating: (v) => set({ isHydrating: v }),
}));
